import { isCustomFilter } from "../../model";

export function clearCustomFiltersReducer(state) {
  state.filters = state.filters.filter((filter) => !isCustomFilter(filter));
}
